import ScButton from "@/src/components/ui-kit/button";
import { WikiFeedback } from "@/src/models/wiki.models";
import { useUpdateWikiFeedbackResolved } from "@/src/services/wiki/wiki-feedback.hooks";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type FeedbackCardProps = Readonly<{
  feedback: WikiFeedback;
}>;

const FeedbackCard = ({ feedback }: FeedbackCardProps) => {
  const { t } = useTranslation();
  const { mutate: updateResolved, isPending } = useUpdateWikiFeedbackResolved();

  const isResolved = feedback.resolved === true;

  return (
    <View className="flex-col gap-3 p-3 md:border md:border-ash-3 rounded-xl">
      <Text className="text-sm font-medium text-onyx">{t("LABEL_ANONYMOUS")}</Text>

      <View className="bg-ash px-4 py-3 rounded-xl">
        <Text className="text-sm text-onyx" numberOfLines={6}>
          {feedback.message}
        </Text>
      </View>

      <View className="flex-row items-center justify-between">
        <Text className="text-xs text-ash-2">
          {new Date(feedback.CreatedDate).toLocaleDateString()}
        </Text>

        <ScButton
          text={isResolved ? "BTN_MARK_PENDING" : "BTN_MARK_RESOLVED"}
          mode="outlined"
          disabled={isPending}
          loading={isPending}
          className="px-3 py-1 self-auto"
          textClassName="text-xs"
          onPress={() =>
            updateResolved({ itemId: feedback.ItemId, resolved: !isResolved })
          }
        />
      </View>
    </View>
  );
};

export default FeedbackCard;
